import { useState, useEffect } from 'react';

export const useLocationPermission = (): boolean => {
  const [isLocationEnabled, setIsLocationEnabled] = useState<boolean>(false);

  useEffect(() => {
    if (!navigator.geolocation) {
      setIsLocationEnabled(false);
      return;
    }

    // First try to check permissions API (if available)
    if ('permissions' in navigator) {
      navigator.permissions.query({name: 'geolocation'}).then((result) => {
        if (result.state === 'granted') {
          setIsLocationEnabled(true);
          return;
        } else if (result.state === 'denied') {
          setIsLocationEnabled(false);
          return;
        }
        // If 'prompt' or Safari returns wrong state, fallback to actual geolocation test
        testGeolocation();
      }).catch(() => {
        // Permissions API not supported, fallback to geolocation test
        testGeolocation();
      });
    } else {
      testGeolocation();
    }

    function testGeolocation() {
      navigator.geolocation.getCurrentPosition(
        () => setIsLocationEnabled(true),
        (error) => {
          // Only set to false for actual permission denial, not timeouts
          if (error.code === error.PERMISSION_DENIED) {
            setIsLocationEnabled(false);
          } else {
            // For timeout or position unavailable, assume permission exists but location failed
            setIsLocationEnabled(true);
          }
        },
        { 
          timeout: 8000, // Longer timeout for Safari
          enableHighAccuracy: false,
          maximumAge: 300000 // Cache position for 5 minutes
        }
      );
    }
  }, []);

  return isLocationEnabled;
};